module.exports = __webpack_public_path__ + "static/img/14000529.d57c1ed0.png";